
import { Component, Mixins, Watch } from 'vue-property-decorator';
import { patchPreferences } from '@/features/settings/services/preferences.services';
import { StoreForImport } from '@/features/shipment/types';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';
import { fetchAndCommitIntegrationConnectedData } from '@/features/ecommerce/helpers/eCommerce';
import { PreferencesMixin } from './mixins';

@Component
export default class Ecommerce extends Mixins(PreferencesMixin, ResponsivenessMixin) {
  private showEcommercePrefsAlert = {
    success: false,
    show: false,
  };

  private formEcommerce: StoreForImport = {
    id: 0,
    platformType: '',
    shopDetails: {
      name: '',
      url: '',
    },
    allowedOptions: {
      fulfillOrder: false,
      storeNotification: false,
    },
  }

  private isInsurance = false;

  get stores(): Array<StoreForImport> {
    return this.$store.getters.getStoresForImport;
  }

  get isUserPreferences(): number {
    return this.$store.getters.getIsUserPreferences;
  }

  get isInitialDataLoaded(): number {
    return this.$store.getters.getIsInitialDataLoaded;
  }

  @Watch('isUserPreferences', { immediate: true })
  private populatePreferences(newValue: number) {
    if (newValue) {
      const { ecommerce } = this.userPreferences;
      this.isInsurance = ecommerce.insurance;
    }
  }

  @Watch('stores.length', { immediate: true })
  private updateDefaultStore(newValue: number) {
    if (!newValue) return;

    const { ecommerce } = this.userPreferences;
    if (ecommerce.defaultStore) {
      const currentStore = this.stores.find((store) => store.id === ecommerce.defaultStore?.id);
      if (currentStore) {
        this.formEcommerce = {
          ...currentStore,
          allowedOptions: {
            fulfillOrder: ecommerce.fulfillOrder,
            storeNotification: ecommerce.storeNotification,
          },
        };
      }
    }
  }

  @Watch('isInitialDataLoaded', { immediate: true })
  // eslint-disable-next-line class-methods-use-this
  private loadStoreItems(newValue: number) {
    if (!newValue) return;
    fetchAndCommitIntegrationConnectedData();
  }

  private async updateEcommercePreference({ path, value }: {
    path: string,
    value: unknown,
  }) {
    this.patchPreferenceInStore(`ecommerce/${path}`, value);

    const response = await patchPreferences(this.userPreferences.id, [
      {
        path: `ecommerce/${path}`,
        op: 'replace',
        value,
      },
    ]);

    this.showEcommercePrefsAlert = {
      show: true,
      success: !!response,
    };
  }
}
